const EXTENSION_TYPE_ARRAY = ['local', 'global'] as const;
export type ExtensionType = (typeof EXTENSION_TYPE_ARRAY)[number];
export type ModuleType = 'module' | 'folder' | ExtensionType;
export const isExtensionType = (
  testType: ModuleType,
): testType is ExtensionType => EXTENSION_TYPE_ARRAY.includes(testType as any);

export enum ModuleTypeValue {
  MODULE = 'module',
  LOCAL_EXTENSION = 'local',
  GLOBAL_EXTENSION = 'global',
}

export type ModuleIconNameType =
  | 'messages'
  | 'files'
  | 'billing'
  | 'forms'
  | 'knowledge'
  | 'payments'
  | 'contracts';

export type ExtensionIconNameType =
  | 'dashboard'
  | 'keywords'
  | 'backlinks'
  | 'extension'
  | 'linegraph'
  | 'piechart'
  | 'shapes'
  | 'visible'
  | 'cube'
  | 'venn';

export type IconNameType = ExtensionIconNameType | ModuleIconNameType;
